import React, { Fragment, useEffect, useState } from 'react';
import './style.css';
import { connect } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../../_services/api.service';
import { APILoader } from '../../../components/APILoader';
import JoinRMPFamily from '../../../components/JoinRMPFamily';
import RatingSelector from '../../../components/RatingSelector';
import { Input } from '@mui/material';
import { toast } from 'react-toastify';
import getColor from '../../../_helpers/getColor';
import getImageURL from '../../../_helpers/getImageURL';
import RatingForm from '../../../components/RatingForm';
import Modal from '../../../components/Modal';

const Adjuster = ({ infosetting, user, loggedIn }) => {
    const params = useParams();
    const navigate = useNavigate();
    const [adjuster, setAdjuster] = useState(null);
    const [ratings, setRatings] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [userRating, setUserRating] = useState(null);
    const [userRatingChecked, setUserRatingChecked] = useState(false);
    const [currentIp, setCurrentIp] = useState(null);
    const [replyIndex, setReplyIndex] = useState(-1);
    const [replyText, setReplyText] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [reviewToEdit, setReviewToEdit] = useState(null);

    useEffect(() => {
        fetch('https://api.ipify.org?format=json')
            .then(response => response.json())
            .then(data => {
                setCurrentIp(data.ip);
            }).catch(error => {
                console.log('Error:', error);
            });
    }, []);

    useEffect(() => {
        if (infosetting && adjuster) {
            document.title = `${adjuster.first_name} | ${infosetting.title}`;
        }
    }, [adjuster, infosetting]);


    useEffect(() => {
        if (params.id) {
            setUserRatingChecked(false);
            apiService.getSingle("adjusters", params.id)
                .then(setAdjuster)
                .catch(e => {
                    navigate('/');
                });
        }
    }, [params]);

    useEffect(() => {
        if (adjuster) {
            fetchRatings();
        }
    }, [adjuster]);

    const fetchRatings = () => {
        apiService.filter('adjuster-ratings', { query: { adjuster: adjuster._id } })
            .then(setRatings);
    }

    useEffect(() => {
        setReplyText("");
    }, [replyIndex]);

    useEffect(() => {
        if (ratings && adjuster && currentIp && user) {
            let aRatingIndex = ratings.findIndex(r => r.ipAddress === currentIp);
            setUserRating(aRatingIndex > -1 ? ratings[aRatingIndex] : null);
            setUserRatingChecked(true);
        }
    }, [ratings, adjuster, currentIp, user]);

    const onReviewSubmit = async (ratingValue, reviewText, images, isUpdate = false) => {
        try {
            if (currentIp) {
                setLoading(true);
                const submitData = new FormData();
                submitData.append('rating', ratingValue);
                submitData.append('review', reviewText);
                submitData.append('user', user._id);
                submitData.append('adjuster', adjuster._id);
                submitData.append('ipAddress', currentIp);

                if (!isUpdate && images.length > 0) {
                    images.forEach((image) => {
                        submitData.append(`images`, image.file);
                    })
                }

                if (isUpdate && images.length > 0) {
                    images.filter(img => img.preview.includes("data:image"))
                        .forEach((image) => {
                            submitData.append(`images`, image.file);
                        });


                    let existing_images = images.filter(img => img.preview.includes("uploads")).map(image => { return { path: `/public/${image.preview.split("/public/")[1]}` } })
                    if (existing_images.length > 0) {
                        submitData.append(`existing_images`, JSON.stringify(existing_images));
                    }
                }
                
                if (isUpdate) {
                    await apiService.updateWithFile('adjuster-ratings', submitData, reviewToEdit._id);
                    fetchRatings();
                    setReviewToEdit(null);
                    setLoading(false);
                }
                else {
                    await apiService.addWithFile('adjuster-ratings', submitData);
                    window.location.reload();
                }
            }
        } catch (e) {
            window.alert(e);
            toast.error(`An internal error occurred!`);
            setLoading(false);
        }
    }

    const onReplySubmit = async (e, index) => {
        e.preventDefault();
        if (replyText.trim().length === 0) {
            return toast.error("Please enter your reply then submit!");
        }

        let ratingsArr = JSON.parse(JSON.stringify(ratings));
        let rating = ratingsArr[index];
        rating["replies"] = rating["replies"] ? rating["replies"] : [];
        rating.replies.push({
            from: {
                _id: user._id,
                name: user.name,
                profileImage: user.profileImage
            },
            text: replyText,
            dateTime: new Date().getTime()
        });
        ratingsArr[index] = rating;
        setRatings(ratingsArr);
        setReplyIndex(-1);

        await apiService.update('adjuster-ratings', rating, rating._id);
    }

    const onDeleteReply = async (index, rIndex) => {
        if (window.confirm("Are you sure you want to delete your reply?")) {
            let ratingsArr = JSON.parse(JSON.stringify(ratings));
            let rating = ratingsArr[index];
            rating.replies.splice(rIndex, 1);
            ratingsArr[index] = rating;
            setRatings(ratingsArr);
            await apiService.update('adjuster-ratings', rating, rating._id);
        }
    }

    const onDeleteSubReply = async (index, rIndex) => {
        if (window.confirm("Are you sure you want to delete your reply?")) {
            let ratingsArr = JSON.parse(JSON.stringify(ratings));
            let rating = ratingsArr[index];
            rating.replies[rIndex]["response"] = null;
            rating.replies[rIndex]["responseDateTime"] = null;
            ratingsArr[index] = rating;
            setRatings(ratingsArr);
            await apiService.update('adjuster-ratings', rating, rating._id);
        }
    }

    const onSubReplySubmit = async (e, index, rIndex, text) => {
        e.preventDefault();
        let ratingsArr = JSON.parse(JSON.stringify(ratings));
        let rating = ratingsArr[index];
        rating.replies[rIndex]["response"] = text;
        rating.replies[rIndex]["responseDateTime"] = new Date().getTime();

        ratingsArr[index] = rating;
        setRatings(ratingsArr);
        await apiService.update('adjuster-ratings', rating, rating._id);
    }
    const ReplyContainer = ({ ratingUser, reply, index, rIndex, isMyReply }) => {
        const [replyActive, setreplyActive] = useState(false);
        const [subReply, setSubReply] = useState("");

        useEffect(() => {
            setSubReply("");
        }, [replyActive]);

        return <Fragment>
            <div className='adjuster-item row p-rating-item' key={rIndex}>
                <div className='a-rating-container column'>
                    <img src={getImageURL(reply.from.profileImage)} className='mt-10 a-reply-profile-image' />
                </div>
                <div className='a-name-container column p-rating-item-name'>
                    <span className='a-name'>{reply.from.name}</span>
                    <span className='ap-review-text'>{reply.text}</span>
                </div>
                <div className='a-state-container a-state-container-adjuster column'>
                    <span className='a-state-name'>
                        {user && reply.from._id === user._id && <i className='fa-solid fa-trash text-danger cursor-pointer a-reply-trash' onClick={() => onDeleteReply(index, rIndex)}></i>}
                        <span className='ml-5'>{new Date(reply.dateTime).toLocaleDateString()}</span>
                    </span>
                    {isMyReply && !replyActive && !reply.response && reply.from._id !== ratingUser._id ? <button className='btn btn-primary btn-sm btn-response btn-reply-mobile' onClick={() => setreplyActive(true)}>Reply</button> : null}
                </div>
            </div>
            {reply.response && <div className='a-response-container column'>
                <div className='a-response-content'>
                    <div className='adjuster-item row p-rating-item'>
                        <div className='a-rating-container column'>
                            <img src={getImageURL(ratingUser.profileImage)} className='mt-10 a-reply-profile-image' />
                        </div>
                        <div className='a-name-container column p-rating-item-name'>
                            <span className='a-name'>{ratingUser.name}</span>
                            <span className='ap-review-text'>{reply.response}</span>
                        </div>
                        <div className='a-state-container a-state-container-adjuster column'>
                            <span className='a-state-name'>
                                {isMyReply ? <i className='fa-solid fa-trash text-danger cursor-pointer a-reply-trash' onClick={() => onDeleteSubReply(index, rIndex)}></i> : null}
                                <span className='ml-5'>{new Date(reply.dateTime).toLocaleDateString()}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>}


            {replyActive && <div className='a-response-container column'>
                <div className='a-response-content'>
                    <form className='a-reply-input-container' onSubmit={(e) => onSubReplySubmit(e, index, rIndex, subReply)}>
                        <Input placeholder='Add a reply...' className='a-reply-input' name='reply' value={subReply} onChange={(e) => setSubReply(e.target.value)} />
                        <div className='a-reply-input-button row mt-20 mb-20'>
                            <button type="button" className='btn btn-white btn-sm btn-response' onClick={() => setreplyActive(false)}>Cancel</button>
                            <button type='submit' className='btn btn-primary btn-sm btn-response ml-10' >Reply</button>
                        </div>
                    </form>
                </div>
            </div>}
        </Fragment>
    }

    const openImageModal = (imageUrl) => {
        setSelectedImage(imageUrl);
    }

    const closeImageModal = () => {
        setSelectedImage(null);
    }

    return (
        <Fragment>
            {selectedImage && (
                <div className="image-modal-overlay" onClick={closeImageModal}>
                    <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close-button" onClick={closeImageModal}>×</button>
                        <img src={selectedImage} alt="Review attachment full size" className="modal-image" />
                    </div>
                </div>
            )}

            {adjuster && <Modal isOpen={reviewToEdit ? true : false}
                title="Edit Review"
                onClose={() => setReviewToEdit(null)} >
                <RatingForm isLoading={isLoading} infosetting={infosetting} defaultData={reviewToEdit} onReviewSubmit={onReviewSubmit} />
            </Modal>}

            <div className='height100 padder'>
                {adjuster ? <div className='ap-container'>
                    <div className='ap-detail-content'>
                        <div className='ap-detail-item column'>
                            <div className='ap-rating-display'>
                                <span className='ap-rating-v'>{adjuster.rating}</span>
                                <span className='ap-rating-total'>/ 5</span>
                            </div>
                            {ratings && (ratings.length > 0 ?
                                <span className='ap-rating-caption'>Overall Quality Based on {ratings.length} ratings</span>
                                :
                                <span className='ap-rating-caption'>No Rating Yet!</span>)
                            }

                            <span className='ap-adjuster-name'>{adjuster.first_name} {adjuster.last_name}</span>
                            <span className='ap-rating-caption'>Adjuster at
                                <Link to={`/search?q=${encodeURI(adjuster.companyObj.name)}`}>{adjuster.companyObj.name}</Link>in
                                <Link to={`/search?q=${encodeURI(adjuster.stateObj.name)}`}>{adjuster.stateObj.name}</Link>
                            </span>

                            {adjuster.additionalInfo && <div className='mt-10'>
                                <h3 className=''>Additional Information</h3>
                                <div dangerouslySetInnerHTML={{ __html: adjuster.additionalInfo }} className='ap-additional-info-container'>
                                </div>
                            </div>
                            }
                        </div>
                        <div className='ap-rating-form'>
                            <div className='padder'>
                                <div className='crud-container'>
                                    {loggedIn ?
                                        userRatingChecked ?
                                            userRating ? <div className='ap-rating-form-content column center ap-rating-done'>
                                                <i class="fa-solid fa-circle-check secondary-text"></i>
                                                <h3>You Rated this Adjuster</h3>
                                                <RatingSelector value={userRating.rating} />
                                                <p className='ap-rating-caption text-center mt-20'>Adjuster already rated by you.<br />Thank you for your feedback and review.</p>
                                            </div>
                                                : <RatingForm isLoading={isLoading} infosetting={infosetting} onReviewSubmit={onReviewSubmit} />
                                            :
                                            <div className='row center height60'>
                                                <APILoader />
                                            </div>
                                        :
                                        <JoinRMPFamily infosetting={infosetting} redirect={`/adjuster/${params.id}`} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    {ratings && ratings.length > 0 && <div div className='ap-ratings'>
                        <h3>{ratings.length} Rating{ratings.length > 1 ? 's' : ''}</h3>
                        <hr className='hr2' />
                        <div className='adjusters-container'>
                            {ratings.map((rating, index) => <div className='adjuster-main-item'>
                                <div className='adjuster-item row p-rating-item'>
                                    <div className='a-rating-container column'>
                                        <span className='a-rating-heading'>Rating</span>
                                        <div className='a-rating-box row center' style={{ backgroundColor: getColor(rating.rating) }}>
                                            <span className='a-rating'>
                                                {rating.rating}{rating.rating.toString().length === 1 ? '.0' : ''}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='a-name-container column p-rating-item-name'>
                                        <span className='a-name'>{rating.userObj.name}</span>
                                        <span className='ap-review-text'>{rating.review}</span>

                                        {rating.images && rating.images.length > 0 && (
                                            <div className="review-images-section">
                                                <h4>Photos ({rating.images.length})</h4>
                                                <div className="review-images">
                                                    {rating.images.map((image) => (
                                                        <div
                                                            key={image._id}
                                                            className="image-thumbnail-container"
                                                            onClick={() => openImageModal(getImageURL(image.path))}
                                                        >
                                                            <img
                                                                src={getImageURL(image.path)}
                                                                alt="Review attachment"
                                                                className="image-thumbnail"
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className='a-state-container a-state-container-adjuster column'>
                                        <div className='column a-state-container-adjuster-top'>
                                            <span className='a-state-name'>{new Date(rating.dateTime).toLocaleDateString()}</span>
                                            {user && rating.user === user._id && <span className='secondary-text edit-btn' onClick={() => setReviewToEdit(rating)}>Edit</span>}
                                        </div>

                                        {replyIndex !== index && user && <button className='btn btn-primary btn-sm btn-response btn-reply-mobile' onClick={() => setReplyIndex(index)}>Reply</button>}
                                    </div>
                                </div>
                                <div className='a-response-container column'>
                                    <div className='a-response-content'>
                                        {rating.replies && rating.replies.length ?
                                            rating.replies.map((reply, rIndex) => <ReplyContainer ratingUser={rating.userObj} reply={reply} index={index} rIndex={rIndex} isMyReply={user && rating.user === user._id ? true : false} />)
                                            : null
                                        }
                                        {replyIndex === index && <form className='a-reply-input-container' onSubmit={(e) => onReplySubmit(e, index)}>
                                            <Input placeholder='Add a reply...' className='a-reply-input' name='reply' value={replyText} onChange={(e) => setReplyText(e.target.value)} />
                                            <div className='a-reply-input-button row mt-20 mb-20'>
                                                <button type="button" className='btn btn-white btn-sm btn-response' onClick={() => setReplyIndex(-1)}>Cancel</button>
                                                <button type='submit' className='btn btn-primary btn-sm btn-response ml-10' >Reply</button>
                                            </div>
                                        </form>}
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                    </div>}
                </div> :
                    <div className='row center height60'>
                        <APILoader />
                    </div>
                }
            </div>
        </Fragment>

    );
};


function mapStateToProps(state) {
    return { ...state.authentication, ...state };
}

export default connect(mapStateToProps)(Adjuster);